export default __webpack_public_path__ + "static/media/icon-timer.9dab7b2a.svg";